'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './ldap-db.routes';

export class LdapDBComponent {
  constructor(SettingsService, Auth, $state, dialogs, $http) {
    'ngInject';

    this.SettingsService = SettingsService;
    this.dialogs = dialogs;
    this.$state = $state;
    this.$http = $http;

    this.search = "";

    this.ldapdb = SettingsService.getLDAPDB();

    this.treeOptions = {
      nodeChildren: "sub",
      dirSelectable: true,
      injectClasses: {
        ul: "a1",
        li: "a2",
        liSelected: "a7",
        iExpanded: "a3",
        iCollapsed: "a4",
        iLeaf: "a5",
        label: "a6",
        labelSelected: "a8"
      }
    };

    /* Picklist test */
    this.tselected = [];
    this.toptions = [{
      id: 1,
      name: "Option 1"
    }, {
      id: 2,
      name: "Option 2"
    }, {
      id: 3,
      name: "Option 3"
    }]

  }

  applySearch() {

    let SEARCH = this.search.toLowerCase();

    let TREE = angular.copy(this.data);

    let rFn = (node, search, folderHit) => {
      let found = node.entry.toLowerCase().indexOf(search) !== -1;

      node.visible = found;

      /*
      if (found)
        return true;
      */

      let subFound = !!folderHit;

      let parentFolderHit = found || folderHit;

      if (node.sub.length) {
        for (let i=0; i<node.sub.length; i++) {
          let ret = rFn(node.sub[i], search, parentFolderHit);
          //node.children.forEach(subNode => rFn(subNode, search));
          if (ret)
            subFound = true;
        }
      }

      let retVal = found || subFound;

      if (retVal)
        node.visible = true;

      return retVal;
    };

    TREE.forEach(mainCat => rFn(mainCat, SEARCH));


    let newTree = [];
    let pFn = (node,o,root) => {

      if (node.visible) {

        //if (root) {

        o.push({
          entry: node.entry,
          fields: node.fields,
          json: node.json,
          data: node.data,
          sub: []
          /*
          id: node.id,
          nodeId: node.nodeId,
          name: node.name,
          description: node.description,
          docId: node.docId,
          children: []*/
        });

        // } else {



        // }

        node.sub.forEach(child => pFn(child, o[o.length-1].sub,false ));
      }

    };

    TREE.forEach(rootNode => pFn(rootNode, newTree, true));

    //console.log("++++++++");
    //console.log(newTree);

    this.filteredData = newTree;

  }

  resetSearch() {
    this.search = '';
    this.applySearch();
  }

  applyFilter() {
    let keys = Object.keys(this.ldapdb);
    let filteredKeys = keys.filter(key => key.includes(this.filter));

    let _data = [{
      "entry": "o=conduu",
      "sub": [{
        "entry": "ou=users, o=conduu",
        "sub": []
      },{
        "entry": "ou=directory, o=conduu",
        "sub": []
      },{
        "entry": "ou=webaccess, o=conduu",
        "sub": []
      },{
        "entry": "ou=quickbooks, o=conduu",
        "sub": []
      },{
        "entry": "ou=recipientLists, o=conduu",
        "sub": []
      },{
        "entry": "ou=connectedAccounts, o=conduu",
        "sub": []
      },{
        "entry": "ou=evotingProperties, o=conduu",
        "sub": []
      },{
        "entry": "ou=contactProperties, o=conduu",
        "sub": []
      },{
        "entry": "ou=voterGroups, o=conduu",
        "sub": []
      },{
        "entry": "ou=evotingAccess, o=conduu",
        "sub": []
      },{
        "entry": "ou=contact, o=conduu",
        "sub": []
      }]
    }];

    //filteredKeys.forEach(key => data.push(this.ldapdb[key]));

    filteredKeys.forEach(cn => {
      try {
        let splittedCN = cn.split(", ");

        if (splittedCN.length < 3)
          return;

        let folder = [splittedCN[1], splittedCN[2]].join(", ");
        let idx = _data[0].sub.findIndex(o => o.entry == folder);

        let item = this.ldapdb[cn];
        let fJson = null;
        let fData = null;

        if (item.json) {
          fJson = JSON.parse(item.json);
          delete item.json;

          if (fJson.password) {
            fJson.password = "***";
          }
        }

        if (item.data) {
          fData = JSON.parse(item.data);
          delete item.data;

          if (fData.password) {
            fData.password = "***";
          }
        }

        if (item.userPassword) {
          item.userPassword = "***";
        }

        _data[0].sub[idx].sub.push({
          entry: splittedCN[0],
          fields: item,
          json: fJson,
          data: fData,
          sub: []
        })
      } catch (err) {
        console.log(cn);
        console.log(err);
      }
    });

    this.data = _data;
    this.applySearch();
  }

  showSelected(node) {
    this.activeTab = 0;
  }

  rebuild() {
    this.SettingsService.rebuildLDAPB();
  }

  testEmail() {
    this.$http({
      method: 'GET',
      url: '/api/integrations/test-mail/' + this.email
    }).then(res => {})
  }
}

export default angular.module('conduu.ldapDb', [uiRouter])
  .config(routes)
  .component('ldapDb', {
    template: require('./ldap-db.html'),
    controller: LdapDBComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/ldap-db/ldap-db.component.js